'use strict';

const storage = require('./storage-helper');

const { getUrl } = require('./slug-helper');

function handleSuccessResponse(outlink, response, routes, referralSource) {
  const data = {
    ...response,
    isLimited: response.isLimitedGlobally || response.isLimitedPerUser,
    type: 'REDEEM',
  };

  storage.setItem('@redemption', data);

  if (outlink) {
    const params = [];

    const eventId = storage.getItem('eventId');

    if (eventId) {
      params.push(`eventId=${eventId}`);
      storage.setItem('eventId', '');
    }

    if (referralSource) {
      params.push(`referralSource=${referralSource}`);
    }

    const route = getUrl(
      routes.outlink.main.replace('{offerId}', data.offerId),
      params
    );

    outlink.location.replace(route);
  }

  return data;
}

function handleFailResponse(outlink, error) {
  if (outlink) {
    outlink.close();
  }

  return {
    type: 'ALERT',
    errorCode: error,
    alertMessage: 'GeneralError',
  };
}

function isBackTabRedirectActive(offerType) {
  const { doBackTabRedirect } = window.Groupon.Utils.getConfigFromDom();

  return doBackTabRedirect && offerType === 'OnlineCode';
}

function fetchHandler({ endpoint, routes, referralSource, outlink }) {
  return window
    .fetch(endpoint)
    .then(response => {
      if (response.status !== 200) {
        throw new Error(response.status);
      }

      return response
        .json()
        .then(data =>
          handleSuccessResponse(outlink, data, routes, referralSource)
        );
    })
    .catch(error => handleFailResponse(outlink, error && error.message));
}

function redemptionHandler({
  offerId,
  routes,
  referralSource,
  openOutlink = true,
  action = 'main',
  offerType,
}) {
  const endpoint = routes.redemption[action].replace('{offerId}', offerId);

  if (isBackTabRedirectActive(offerType)) {
    storage.setItem('couponRedeemed', true);

    if (openOutlink) {
      window.open(window.location.href, '_blank');
    }

    return fetchHandler({ endpoint, routes, referralSource, outlink: window });
  }

  const outlink = openOutlink ? window.open('about:blank', '_blank') : null;

  return fetchHandler({ endpoint, routes, referralSource, outlink });
}

module.exports = redemptionHandler;
